<template>
  <ion-page>
    <Background></Background>
    <FabColumn>
      <BackButton back_url="home"></BackButton>
    </FabColumn>
    <ion-content>
      <div class="flow-content test-prepare-flow">
        <PrepareTips class="prepare-tips"></PrepareTips>
        <ConfirmButton class="prepare-button" text="準備好了！" position="relative" @click="goTest"></ConfirmButton>
        <div class="prepare-organization">
          <LaunchSponsor class="prepare-sponsor"></LaunchSponsor>
          <LaunchDonate class="prepare-donate"></LaunchDonate>
        </div>
      </div>
    </ion-content>

  </ion-page>
</template>

<script>
import { IonContent, IonPage } from "@ionic/vue";
import Background from "../components/common/Background";
import PrepareTips from "../components/common/PrepareTips";
import LaunchSponsor from "../components/launch/LaunchSponsor";
import LaunchDonate from "../components/launch/LaunchDonate";
import router from "../router";
import ConfirmButton from "../components/common/ConfirmButton";
import BackButton from "../components/common/BackButton";
import common from "../common";

export default {
  name: "LoginPrepare",
  components: {
    BackButton,
    ConfirmButton,
    LaunchDonate,
    LaunchSponsor,
    PrepareTips,
    Background,
    IonPage,
    IonContent
  },

  methods: {
    goTest: function () {
      common.getUserInfo().then(user_info => {
        const loading = common.showLoading();
        common.apiGetData('/getTestQuestion?user_id=' + user_info.id, true, loading).then(res => {
          if (res === false) {
            return false;
          }
          common.setStorage('test_data', res)
          router.replace('/test')
        })
      })

    }
  }
}
</script>

<style scoped>
.test-prepare-flow {
  align-items: center;
  justify-content: flex-start;
  padding: clamp(1rem, 3vw, 2rem) clamp(1rem, 4vw, 2rem);
}

.prepare-tips :deep(.title) {
  margin-top: clamp(3rem, 12vh, 6rem);
}

.prepare-tips :deep(.sub-title) {
  margin: clamp(1rem, 2.5vw, 1.5rem) auto 0;
}

.prepare-button :deep(.relative) {
  margin: clamp(1rem, 2.5vw, 1.5rem) auto 0;
}

.prepare-button :deep(.box) {
  width: clamp(12rem, 30vw, 18rem);
}

.prepare-organization {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: clamp(2rem, 5vw, 4rem);
  width: min(100%, 40rem);
  margin: clamp(1.25rem, 3vw, 2rem) auto 0;
}

.prepare-sponsor,
.prepare-donate {
  box-sizing: border-box;
  height: auto;
  margin: 0;
  padding-top: 0;
}

.prepare-sponsor {
  flex: 0 1 13rem;
}

.prepare-donate {
  flex: 0 1 18rem;
}

.prepare-sponsor :deep(.text),
.prepare-donate :deep(.text) {
  margin-bottom: clamp(0.375rem, 1vw, 0.625rem);
  line-height: 1.3;
}

.prepare-sponsor :deep(.img),
.prepare-donate :deep(.img) {
  display: block;
  width: 100%;
  height: auto;
  margin: 0 auto;
  object-fit: contain;
}

@media (orientation: landscape) and (max-height: 480px) {
  .prepare-tips :deep(.title) {
    margin-top: clamp(1rem, 5vh, 2rem);
  }

  .prepare-button :deep(.relative) {
    margin-top: clamp(0.625rem, 1.5vw, 1rem);
  }

  .prepare-organization {
    gap: clamp(1.25rem, 3vw, 2.5rem);
    margin-top: clamp(0.875rem, 2vw, 1.25rem);
  }

  .prepare-sponsor {
    flex-basis: 11rem;
  }

  .prepare-donate {
    flex-basis: 16rem;
  }
}
</style>
